var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLibraryAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3335 1.83325H7.3335C6.32516 1.83325 5.50016 2.65825 5.50016 3.66659V14.6666C5.50016 15.6749 6.32516 16.4999 7.3335 16.4999H18.3335C19.3418 16.4999 20.1668 15.6749 20.1668 14.6666V3.66659C20.1668 2.65825 19.3418 1.83325 18.3335 1.83325ZM10.7802 12.1733L8.88266 10.2666C8.53433 9.90909 8.53433 9.34075 8.88266 8.98325C9.24016 8.62575 9.81766 8.62575 10.1752 8.98325L11.4218 10.2391L15.4735 6.15075C15.831 5.79325 16.4085 5.79325 16.766 6.15075C17.1143 6.50825 17.1143 7.07659 16.766 7.43408L12.0635 12.1733C11.7243 12.5399 11.1377 12.5399 10.7802 12.1733ZM2.75016 5.49992C2.246 5.49992 1.8335 5.91242 1.8335 6.41659V18.3333C1.8335 19.3416 2.6585 20.1666 3.66683 20.1666H15.5835C16.0877 20.1666 16.5002 19.7541 16.5002 19.2499C16.5002 18.7458 16.0877 18.3333 15.5835 18.3333H4.5835C4.07933 18.3333 3.66683 17.9208 3.66683 17.4166V6.41659C3.66683 5.91242 3.25433 5.49992 2.75016 5.49992Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibraryAdd);
export default __webpack_public_path__ + "static/media/library-add.f3eb386f1469ffaa6f7eccccad8152fe.svg";
export { ForwardRef as ReactComponent };